"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAvailablePracticeExamTemplatesForQuestionBank = useAvailablePracticeExamTemplatesForQuestionBank;
exports.useQuizzesWithRelationships = exports.usePracticeExamsForCurrentQuestionBank = exports.useCurrentUserQuizzes = exports.useCurrentQuiz = void 0;
var _reactRedux = require("react-redux");
var _params = require("./params.js");
var _subscriptions = require("./subscriptions.js");
var _quizzes = require("../selectors/quizzes.js");
var useQuizzesWithRelationships = function useQuizzesWithRelationships() {
  return (0, _reactRedux.useSelector)(_quizzes.selectQuizzesWithRelationships);
};
exports.useQuizzesWithRelationships = useQuizzesWithRelationships;
var useCurrentUserQuizzes = function useCurrentUserQuizzes() {
  return (0, _reactRedux.useSelector)(_quizzes.selectCurrentQuizzesWithRelationships);
};
exports.useCurrentUserQuizzes = useCurrentUserQuizzes;
var useCurrentQuiz = function useCurrentQuiz() {
  return (0, _reactRedux.useSelector)(function (state) {
    return (0, _quizzes.selectQuizWithRelationships)(state, (0, _params.useCurrentQuizId)());
  });
};
exports.useCurrentQuiz = useCurrentQuiz;
var usePracticeExamsForCurrentQuestionBank = function usePracticeExamsForCurrentQuestionBank() {
  return (0, _reactRedux.useSelector)(_quizzes.selectPracticeExams);
};
exports.usePracticeExamsForCurrentQuestionBank = usePracticeExamsForCurrentQuestionBank;
function useAvailablePracticeExamTemplatesForQuestionBank() {
  var practiceExams = usePracticeExamsForCurrentQuestionBank();
  var practiceExamAccessIds = (0, _subscriptions.usePracticeExamTemplateAccessIdsForUser)();
  var templates = (0, _reactRedux.useSelector)(function (state) {
    return state.practiceExamTemplates;
  });
  if (practiceExams.size) {
    templates = templates.filter(function (template) {
      return template.get('board_name') === practiceExams.first().get('board_name') && practiceExamAccessIds.includes(template.get('id'));
    });
  }
  var selectedQuestionBankId = (0, _reactRedux.useSelector)(function (state) {
    return state.session.get('selected_question_bank_id');
  });
  var templatesForBank = templates.toList().filter(function (template) {
    return template.get('question_bank_id') === selectedQuestionBankId;
  });
  return templatesForBank;
}